const chartDirectives = angular.module('chartDirectives', []);

chartDirectives.directive('chart', function($timeout, $rootScope, chartColorService) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/common/chart/chart-module.html',
    scope: {
      config: '=',
    },
    controller: [
      '$scope',
      '$element',
      function($scope, $element) {
        const chartElement = $element.children('.chart');

        let chart = null;

        const chartDefaults = {
          chart: {
            backgroundColor: 'white',
          },
          credits: {
            enabled: false,
          },
          title: {
            text: null,
          },
          plotOptions: {
            line: {
              marker: {
                symbol: 'circle',
                radius: 3,
              },
              states: {
                hover: {
                  lineWidthPlus: 0,
                },
              },
            },
            pie: {
              dataLabels: {
                enabled: false,
              },
              showInLegend: true,
              colors: chartColorService.getAllColors(),
            },
            area: {
              marker: {
                symbol: 'circle',
                radius: 3,
              },
              states: {
                hover: {
                  lineWidthPlus: 0,
                },
              },
              fillOpacity: 0,
            },
          },
          tooltip: {
            shared: true,
            crosshairs: true,
            pointFormatter: function (a, b, c) {
              return (
                '<span style="color:' +
                this.color +
                '">●</span> ' +
                this.series.name +
                ': <b>' +
                +(Math.round(this.y + 'e+3') + 'e-3') +
                '</b><br/>'
              );
            },
          },
          xAxis: {
            gridLineWidth: 1,
            tickWidth: 5,
            lineWidth: 1.5,
            tickLength: 5,
            tickColor: '#002C65',
            gridLineColor: 'rgba(0,44,101,0.4)',
            labels: {
              style: {
                color: '#002C65',
                'font-weight': 500,
                'font-size': '14px',
              },
            },
          },
          yAxis: {
            gridLineWidth: 1,
            tickWidth: 5,
            lineWidth: 1.5,
            tickLength: 5,
            tickColor: '#002C65',
            gridLineColor: 'rgba(0,44,101,0.4)',
            labels: {
              style: {
                color: '#002C65',
                'font-weight': 500,
                'font-size': '14px',
              },
            },
            min: 0,
          },
          exporting: {
            buttons: {
              contextButton: {
                onclick(e) {
                  // This is required to keep the data table menu option in sync
                  if (!this.insertedTable) {
                    this.updateDataTableText('viewData');
                  } else {
                    this.updateDataTableText('hideData');
                  }

                  // Default implementation of exporting context menu button
                  if (e) {
                    e.stopPropagation();
                  }
        
                  if (!this.tooltip.isHidden) {
                    this.tooltip.hide(0);
                  }
                  const button = this.exportSVGElements[0];
                  this.contextMenu(
                    button.menuClassName,
                    this.options.exporting.buttons.contextButton.menuItems,
                    button.translateX,
                    button.translateY,
                    button.width,
                    button.height,
                    button
                  );
                  button.setState(2);
                }
              }
            },
            chartOptions: {
              chart: {
                backgroundColor: 'white',
              },
            },
            fallbackToExportServer: false,
          },
        };

        $rootScope.$on('window-resize', function() {
          //("chart rezise");
          if (chart) {
            // TODO: if this causes problems in future, some sort of refresher filter might help to prevent too many reflow calls
            $timeout(function() {
              chart.reflow();
            }, 500);
          }
        });

        $scope.$on('reflow', function() {
          if (chart) {
            $timeout(function() {
              chart.reflow();
            }, 0);
          }
        });

        $scope.$on('reload', function() {
          init($scope.config);
        });

        $scope.$watch('config', function() {
          init($scope.config);
        });

        $scope.$watch('config.chart.type', function() {
          init($scope.config);
        });

        $scope.$watch('config.series', function(series) {
          if (processSeries(chart, series)) chart.redraw();
        });

        $scope.$watch('config.xAxis.plotBands', function(plotBands) {
          const xAxis = chart.xAxis[0];

          xAxis.removePlotBand('mask-before');
          xAxis.removePlotBand('mask-after');

          _.each(plotBands, function(band) {
            xAxis.addPlotBand(band);
          });
        });

        $scope.$watch('config.xAxis.min', function(min) {
          if (min && chart) {
            const extremes = chart.xAxis[0].getExtremes();
            chart.xAxis[0].setExtremes(min, extremes.max);
          }
        });

        $scope.$watch('config.xAxis.max', function(max) {
          if (max && chart) {
            const extremes = chart.xAxis[0].getExtremes();
            chart.xAxis[0].setExtremes(extremes.min, max);
          }
        });

        function init(config) {
          config = config || {};
          config = angular.copy(config);

          let options = Highcharts.merge(chartDefaults, {
            chart: {
              renderTo: chartElement[0],
            },
          });

          options = Highcharts.merge(options, config.options);

          delete config.options;

          options = Highcharts.merge(options, config);

          Highcharts.wrap(Highcharts.Axis.prototype, 'getPlotLinePath', function(proceed) {
            const path = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
            if (path) {
              path.flat = false;
            }
            return path;
          });

          chart = new Highcharts.Chart(options);

          $timeout(function() {
            chart.reflow();
          }, 0);
        }

        function processSeries(chart, series) {
          if (!chart) return;

          const usedIds = [];

          _.each(series, function(serie) {
            const id = serie.id;
            const chartSeries = chart.get(id);

            usedIds.push(id);

            if (chartSeries) {
              chartSeries.update(angular.copy(serie), false);
            } else {
              chart.addSeries(angular.copy(serie), false);
            }
          });

          for (let i = chart.series.length - 1; i >= 0; i--) {
            const serie = chart.series[i];

            if (usedIds.indexOf(serie.options.id) === -1) {
              serie.remove(false);
            }
          }

          return true;
        }

        $timeout(function() {
          chart.reflow();
        }, 100);
      },
    ],
  };
});
